// import React, { useState, useEffect, useRef } from "react";
// import Menubar from "../Menubar/Menubar";
// import { Outlet } from "react-router-dom";
// import "../Dashboard/Dashboard.css";
// import { MdCancel } from "react-icons/md";

// import {
//   format,
//   startOfMonth,
//   endOfMonth,
//   startOfWeek,
//   endOfWeek,
//   addDays,
//   isSameMonth,
//   setMonth,
//   setYear,
// } from "date-fns";

// // const months = {
// //   Jan: 31,
// //   Feb: 28,
// //   Mar: 31,
// //   Apr: 30,
// //   May: 31,
// //   Jun: 30,
// //   Jul: 31,
// //   Aug: 31,
// //   Sep: 30,
// //   Oct: 31,
// //   Nov: 30,
// //   Dec: 31,
// // };

// // const generateDates = (days) => {
// //   return Array.from({ length: days }, (_, i) => i + 1);
// // };

// // const isLeapYear = (year) => {
// //   return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
// // };

// const Calendar = () => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);

//       if (mobile) {
//         setIsSidebarOpen(false);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   //   const currentMonth = new Date().toLocaleString("default", { month: "short" });
//   //   const [selectedMonth, setSelectedMonth] = useState(currentMonth);
//   //   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

//   //   if (isLeapYear(selectedYear)) {
//   //     months["Feb"] = 29;
//   //   } else {
//   //     months["Feb"] = 28;
//   //   }

//   //   const years = Array.from(
//   //     { length: 10 },
//   //     (_, i) => new Date().getFullYear() - 5 + i
//   //   );

//   //   const handleMonthChange = (e) => setSelectedMonth(e.target.value);
//   //   const handleYearChange = (e) => setSelectedYear(Number(e.target.value));

//   //   const today = new Date();
//   //   today.setHours(0, 0, 0, 0);

//   //   const isPastDate = (day, month, year) => {
//   //     const selectedDate = new Date(
//   //       year,
//   //       Object.keys(months).indexOf(month),
//   //       day
//   //     );
//   //     selectedDate.setHours(0, 0, 0, 0);
//   //     return selectedDate < today;
//   //   };

//   //   const dummyVillas = [
//   //     { id: 1, villaName: "Villa A", max_bedrooms: 2 },
//   //     { id: 2, villaName: "Villa B", max_bedrooms: 3 },
//   //     { id: 3, villaName: "Villa C", max_bedrooms: 4 },
//   //     { id: 4, villaName: "Villa D", max_bedrooms: 2 },
//   //     { id: 5, villaName: "Villa E", max_bedrooms: 3 },
//   //     { id: 6, villaName: "Villa F", max_bedrooms: 1 },
//   //     { id: 7, villaName: "Villa G", max_bedrooms: 2 },
//   //     { id: 8, villaName: "Villa H", max_bedrooms: 3 },
//   //     { id: 9, villaName: "Villa I", max_bedrooms: 2 },
//   //     { id: 10, villaName: "Villa J", max_bedrooms: 1 },
//   //     { id: 11, villaName: "Villa K", max_bedrooms: 2 },
//   //     { id: 12, villaName: "Villa L", max_bedrooms: 1 },
//   //   ];

//   const today = new Date();
//   const [selectedMonth, setSelectedMonth] = useState(today.getMonth());
//   const [selectedYear, setSelectedYear] = useState(today.getFullYear());
//   const [selectedDate, setSelectedDate] = useState(null);

//   const currentMonth = setMonth(
//     setYear(new Date(), selectedYear),
//     selectedMonth
//   );

//   const bookingsData = {
//     "2025-07-02": [
//       { property: "Villa Mandovi", guest: "Aarav Sharma" },
//       { property: "Villa Arcadia", guest: "Sanya Mehta" },
//     ],
//     "2025-07-05": [{ property: "Villa Celebration", guest: "Nikhil Rao" }],
//     "2025-07-08": [
//       { property: "Villa Serenity", guest: "Leela Thomas" },
//       { property: "Villa Mandovi", guest: "Priya Kapoor" },
//       { property: "Villa Sal", guest: "Ravi Kumar" },
//     ],
//     "2025-07-10": [{ property: "Villa Arcadia", guest: "Meera Joshi" }],
//     "2025-07-12": [
//       { property: "Villa Serenity", guest: "John Doe" },
//       { property: "Villa Arcadia", guest: "Jane Smith" },
//     ],
//     "2025-07-15": [
//       { property: "Villa Celebration", guest: "Rohit Bansal" },
//       { property: "Villa Sal", guest: "Fatima Khan" },
//     ],
//     "2025-07-18": [{ property: "Villa Mandovi", guest: "Ayesha Qureshi" }],
//     "2025-07-20": [
//       { property: "Villa Serenity", guest: "Karan Singh" },
//       { property: "Villa Arcadia", guest: "Alia Roy" },
//     ],
//     "2025-07-22": [{ property: "Villa Celebration", guest: "Alex Roy" }],
//     "2025-07-25": [
//       { property: "Villa Sal", guest: "Vikram Nair" },
//       { property: "Villa Arcadia", guest: "Neha Desai" },
//       { property: "Villa Serenity", guest: "Kabir Shah" },
//       { property: "Villa Celebration", guest: "Shahruk Sheikh" },
//     ],
//   };

//   const monthStart = startOfMonth(currentMonth);
//   const monthEnd = endOfMonth(monthStart);
//   const startDate = startOfWeek(monthStart, { weekStartsOn: 0 });
//   const endDate = endOfWeek(monthEnd, { weekStartsOn: 0 });

//   const rows = [];
//   let days = [];
//   let day = startDate;

//   while (day <= endDate) {
//     for (let i = 0; i < 7; i++) {
//       const fullDate = format(day, "yyyy-MM-dd");
//       const isCurrentMonth = isSameMonth(day, monthStart);
//       const hasBooking = bookingsData[fullDate];

//       days.push(
//         <div
//           key={day}
//           onClick={() => hasBooking && setSelectedDate(fullDate)}
//           className={`border h-28 sm:h-20 p-3 text-sm relative cursor-pointer hover:bg-gray-100
//               ${!isCurrentMonth ? "text-gray-400" : ""}`}
//         >
//           {format(day, "d")}
//           {hasBooking && (
//             <div className="w-1.5 h-1.5 rounded-full bg-green-500 absolute top-2 left-2 transform -translate-x-1/2" />
//           )}

//           {hasBooking && (
//             <div className="absolute bottom-2 right-2 left-2 text-xs leading-tight text-right space-y-[1px]">
//               {bookingsData[fullDate].slice(0, 2).map((b, idx) => (
//                 <div key={idx} className="truncate text-gray-700">
//                   {b.property}
//                 </div>
//               ))}
//               {bookingsData[fullDate].length > 2 && (
//                 <div className="text-gray-400 italic text-[10px]">
//                   +{bookingsData[fullDate].length - 2} more
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       );
//       day = addDays(day, 1);
//     }
//     rows.push(
//       <div className="grid grid-cols-7" key={day}>
//         {days}
//       </div>
//     );
//     days = [];
//   }

//   const months = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   const years = [];
//   for (let y = today.getFullYear() - 5; y <= today.getFullYear() + 5; y++) {
//     years.push(y);
//   }

//   const [showPopup_filter, setShowPopup_filter] = useState(false);
//   const filterRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (filterRef.current && !filterRef.current.contains(event.target)) {
//         setShowPopup_filter(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="flex bg-[#F8F9FA]">
//       <Menubar
//         isOpen={isSidebarOpen}
//         setIsOpen={setIsSidebarOpen}
//         isMobile={isMobile}
//       />

//       <main
//         className={`p-5 lg:p-6 transition-all duration-500 w-full ${
//           isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
//         }`}
//       >
//         <Outlet />

//         {/* Header */}
//         <div className="flex justify-between gap-5 items-start lg:items-center">
//           <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
//             <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
//               Calendar
//             </p>
//           </div>

//           <div className="flex items-center gap-1">
//             <div className="flex items-center">
//               <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
//                 <div className="flex items-center justify-center fill-[#1D2826]">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     id="Isolation_Mode"
//                     data-name="Isolation Mode"
//                     viewBox="0 0 24 24"
//                     width="18"
//                     height="18"
//                   >
//                     <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
//                   </svg>
//                 </div>
//                 <input
//                   type="text"
//                   className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
//                 />
//               </div>

//               <div className="">
//                 <button className="Btn">
//                   <svg
//                     className="svgIcon"
//                     viewBox="0 0 384 512"
//                     height="1em"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
//                   </svg>
//                   <span className="icon2"></span>
//                   <span className="tooltip text-sm">Download</span>
//                 </button>
//               </div>

//               <div className="flex items-center">
//                 <div className="relative inline-block" ref={filterRef}>
//                   <div
//                     onClick={() => setShowPopup_filter((prev) => !prev)}
//                     className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${
//                       showPopup_filter
//                         ? "border-[#1D2826]"
//                         : "border-transparent hover:border-[#1D2826]"
//                     }`}
//                   >
//                     <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? "100%" : "0%",
//                           transform: `translate(${
//                             showPopup_filter ? "-100%" : "0"
//                           }, -50%)`,
//                         }}
//                       ></div>
//                     </div>

//                     <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? "0%" : "100%",
//                           transform: `translate(${
//                             showPopup_filter ? "0" : "-100%"
//                           }, -50%)`,
//                         }}
//                       ></div>
//                     </div>

//                     <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? "100%" : "0%",
//                           transform: `translate(${
//                             showPopup_filter ? "-100%" : "0"
//                           }, -50%)`,
//                         }}
//                       ></div>
//                     </div>
//                   </div>

//                   {showPopup_filter && (
//                     <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
//                       <div className="flex justify-between gap-2">
//                         {["Today", "Week", "Month", "Year"].map((label) => (
//                           <button
//                             key={label}
//                             className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
//                           >
//                             {label}
//                           </button>
//                         ))}
//                       </div>

//                       <div className="flex flex-col gap-2">
//                         <div className="flex items-center gap-2">
//                           <input
//                             type="date"
//                             className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                           />
//                           <span className="text-sm text-gray-500">-</span>
//                           <input
//                             type="date"
//                             className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Button */}
//         {/* <div className="flex justify-between mt-8">
//           <a
//             href="/"
//             className="px-6 z-30 py-2 bg-[#1D2826] rounded-lg text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//           >
//             Add Booking
//           </a>
//         </div> */}

//         {/* Calendar */}
//         <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4 my-10">
//           <div className="flex gap-4">
//             <select
//               value={selectedMonth}
//               onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
//               className="text-sm border px-3 py-1 rounded-lg shadow focus:ring-0 focus:border-black"
//             >
//               {months.map((month, index) => (
//                 <option value={index} key={month}>
//                   {month}
//                 </option>
//               ))}
//             </select>
//             <select
//               value={selectedYear}
//               onChange={(e) => setSelectedYear(parseInt(e.target.value))}
//               className="text-sm border px-3 py-1 rounded-lg shadow focus:ring-0 focus:border-black"
//             >
//               {years.map((year) => (
//                 <option value={year} key={year}>
//                   {year}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         <div className="grid grid-cols-7 mb-2 font-bold text-center">
//           {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
//             <div key={day}>{day}</div>
//           ))}
//         </div>

//         {/* Calendar Grid */}
//         {rows}

//         {selectedDate && (
//           <div
//             className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
//             onClick={() => setSelectedDate(null)}
//           >
//             <div className="bg-white rounded-lg w-96 mx-5 p-4 shadow-xl">
//               <div className="flex justify-between items-start mb-4">
//                 <h3 className="text-lg font-bold">
//                   Bookings on {selectedDate}
//                 </h3>
//                 <button
//                   className="text-gray-400 font-semibold hover:text-gray-700"
//                   onClick={() => setSelectedDate(null)}
//                 >
//                   <MdCancel />
//                 </button>
//               </div>
//               <ul className="space-y-2 max-h-[80vh] overflow-y-auto">
//                 {bookingsData[selectedDate]?.map((b, i) => (
//                   <li
//                     key={i}
//                     className="border p-2 rounded bg-gray-100 text-sm"
//                   >
//                     <strong>{b.property}</strong> <br /> Guest: {b.guest}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         )}

//         {/* <div className="mt-5">
//           <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 ml-2 my-8 lg:mt-0 lg:mb-4">
//             <div className="flex items-center gap-1">
//               <div className="h-[1em] w-[1em] rounded border border-black bg-[#7a7162]"></div>
//               Confirmed Booking
//             </div>
//             <div className="flex items-center gap-1">
//               <div className="h-[1em] w-[1em] rounded border border-black bg-white"></div>
//               Available
//             </div>
//             <div className="flex items-center gap-1">
//               <div className="h-[1em] w-[1em] rounded border border-black bg-[#C0C0C0]"></div>
//               Waiting For Payment
//             </div>
//           </div>

//           <div className="mx-4 md:mx-2 overflow-x-auto">
//             <select
//               value={selectedMonth}
//               onChange={handleMonthChange}
//               className="bg-white border border-[#444444] outline-none rounded-lg px-2 py-1 mb-4"
//             >
//               {Object.keys(months).map((month) => (
//                 <option key={month} value={month}>
//                   {month}
//                 </option>
//               ))}
//             </select>

//             <select
//               value={selectedYear}
//               onChange={handleYearChange}
//               className="bg-white border border-[#444444] outline-none rounded-lg px-2 py-1 mb-4 ml-2"
//             >
//               {years.map((year) => (
//                 <option key={year} value={year}>
//                   {year}
//                 </option>
//               ))}
//             </select>

//             <table style={{ width: "100%" }} className="text-sm 2xl:text-lg">
//               <thead>
//                 <tr>
//                   <th
//                     rowSpan="4"
//                     style={{
//                       backgroundColor: "#ABB0AC",
//                       border: "solid 1px",
//                       borderLeft: "solid 2px",
//                       borderRight: "solid 2px",
//                       padding: "5px",
//                       textAlign: "center",
//                     }}
//                   >
//                     {selectedMonth}
//                   </th>
//                   <th
//                     colSpan="6"
//                     style={{
//                       backgroundColor: "#ABB0AC",
//                       border: "solid 1px",
//                       borderLeft: "solid 2px",
//                       borderRight: "solid 2px",
//                       padding: "5px",
//                       textAlign: "center",
//                     }}
//                   >
//                     LUXURY VILLAS
//                   </th>
//                   <th
//                     colSpan="4"
//                     style={{
//                       backgroundColor: "#ABB0AC",
//                       border: "solid 1px",
//                       borderLeft: "solid 2px",
//                       borderRight: "solid 2px",
//                       padding: "5px",
//                       textAlign: "center",
//                     }}
//                   >
//                     Home Stays
//                   </th>
//                   <th
//                     colSpan="2"
//                     style={{
//                       backgroundColor: "#ABB0AC",
//                       border: "solid 1px",
//                       borderLeft: "solid 2px",
//                       padding: "5px",
//                       textAlign: "center",
//                     }}
//                   >
//                     Hotels
//                   </th>
//                 </tr>
//                 <tr>
//                   {dummyVillas.map((villa, index) => (
//                     <th
//                       key={index}
//                       style={{
//                         backgroundColor: "#DAE0CE",
//                         border: "solid 1px",
//                         padding: "5px",
//                         textAlign: "center",
//                         fontWeight: "500",
//                         borderRight:
//                           index === 5 || index === 9
//                             ? "solid 2px"
//                             : "solid 1px",
//                       }}
//                     >
//                       {villa.villaName}
//                     </th>
//                   ))}
//                 </tr>
//                 <tr>
//                   {dummyVillas.map((villa, index) => (
//                     <th
//                       key={index}
//                       style={{
//                         backgroundColor: "#DAE0CE",
//                         border: "solid 1px",
//                         padding: "5px",
//                         textAlign: "center",
//                         fontWeight: "500",
//                         borderRight:
//                           index === 5 || index === 9
//                             ? "solid 2px"
//                             : "solid 1px",
//                       }}
//                     >
//                       {`${villa.max_bedrooms}BHK`}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody className="font-light">
//                 {generateDates(months[selectedMonth]).map((date, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td
//                       style={{
//                         border: "solid 1px",
//                         borderLeft: "solid 2px",
//                         borderRight: "solid 2px",
//                         padding: "5px",
//                         textAlign: "center",
//                       }}
//                     >{`${selectedMonth} - ${date}`}</td>

//                     {dummyVillas.map((_, colIndex) => {
//                       const cellStyle = {
//                         border: "solid 1px",
//                         padding: "5px",
//                         textAlign: "center",
//                         borderRight:
//                           colIndex === 5 || colIndex === 9
//                             ? "solid 2px"
//                             : "solid 1px",
//                         backgroundColor: "#FFFFFF",
//                       };

//                       return (
//                         <td key={colIndex} style={cellStyle}>
//                           {isPastDate(date, selectedMonth, selectedYear) ? (
//                             <span className="text-gray-500">Not Available</span>
//                           ) : (
//                             <span className="text-black">Available</span>
//                           )}
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <br />
//         </div> */}
//       </main>
//     </div>
//   );
// };

// export default Calendar;
import React, { useState, useEffect, useRef } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { MdCancel } from "react-icons/md";

import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isSameMonth,
  setMonth,
  setYear,
} from "date-fns";

const Calendar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });
  const [bookingsData, setBookingsData] = useState({});

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const res = await fetch(
          "https://demo.zorbastays.com/web-backend/getBookingsByDate",
        );
        const data = await res.json();
        if (data.success) {
          setBookingsData(data.bookings);
        }
      } catch (err) {
        console.error("Error fetching bookings:", err);
      }
    };
    fetchBookings();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const today = new Date();
  const [selectedMonth, setSelectedMonth] = useState(today.getMonth());
  const [selectedYear, setSelectedYear] = useState(today.getFullYear());
  const [selectedDate, setSelectedDate] = useState(null);

  const currentMonth = setMonth(
    setYear(new Date(), selectedYear),
    selectedMonth,
  );

  // const bookingsData = {
  //   "2025-07-02": [
  //     { property: "Villa Mandovi", guest: "Aarav Sharma" },
  //     { property: "Villa Arcadia", guest: "Sanya Mehta" },
  //   ],
  //   "2025-07-05": [{ property: "Villa Celebration", guest: "Nikhil Rao" }],
  //   "2025-07-08": [
  //     { property: "Villa Serenity", guest: "Leela Thomas" },
  //     { property: "Villa Mandovi", guest: "Priya Kapoor" },
  //     { property: "Villa Sal", guest: "Ravi Kumar" },
  //   ],
  //   "2025-07-10": [{ property: "Villa Arcadia", guest: "Meera Joshi" }],
  //   "2025-07-12": [
  //     { property: "Villa Serenity", guest: "John Doe" },
  //     { property: "Villa Arcadia", guest: "Jane Smith" },
  //   ],
  //   "2025-07-15": [
  //     { property: "Villa Celebration", guest: "Rohit Bansal" },
  //     { property: "Villa Sal", guest: "Fatima Khan" },
  //   ],
  //   "2025-07-18": [{ property: "Villa Mandovi", guest: "Ayesha Qureshi" }],
  //   "2025-07-20": [
  //     { property: "Villa Serenity", guest: "Karan Singh" },
  //     { property: "Villa Arcadia", guest: "Alia Roy" },
  //   ],
  //   "2025-07-22": [{ property: "Villa Celebration", guest: "Alex Roy" }],
  //   "2025-07-25": [
  //     { property: "Villa Sal", guest: "Vikram Nair" },
  //     { property: "Villa Arcadia", guest: "Neha Desai" },
  //     { property: "Villa Serenity", guest: "Kabir Shah" },
  //     { property: "Villa Celebration", guest: "Shahruk Sheikh" },
  //   ],
  // };

  const monthStart = startOfMonth(currentMonth);
  const monthEnd = endOfMonth(monthStart);
  const startDate = startOfWeek(monthStart, { weekStartsOn: 0 });
  const endDate = endOfWeek(monthEnd, { weekStartsOn: 0 });

  const rows = [];
  let days = [];
  let day = startDate;

  while (day <= endDate) {
    for (let i = 0; i < 7; i++) {
      const fullDate = format(day, "yyyy-MM-dd");
      const isCurrentMonth = isSameMonth(day, monthStart);
      const hasBooking = bookingsData[fullDate];

      days.push(
        <div
          key={day}
          onClick={() => hasBooking && setSelectedDate(fullDate)}
          className={`border h-28 sm:h-20 p-3 text-sm relative cursor-pointer hover:bg-gray-100 
              ${!isCurrentMonth ? "text-gray-400" : ""}`}
        >
          {format(day, "d")}
          {hasBooking && (
            <div className="w-1.5 h-1.5 rounded-full bg-green-500 absolute top-2 left-2 transform -translate-x-1/2" />
          )}

          {hasBooking && (
            <div className="absolute bottom-2 right-2 left-2 text-xs leading-tight text-right space-y-[1px]">
              {bookingsData[fullDate].slice(0, 2).map((b, idx) => (
                <div key={idx} className="truncate text-gray-700">
                  {b.property}
                </div>
              ))}
              {bookingsData[fullDate].length > 2 && (
                <div className="text-gray-400 italic text-[10px]">
                  +{bookingsData[fullDate].length - 2} more
                </div>
              )}
            </div>
          )}
        </div>,
      );
      day = addDays(day, 1);
    }
    rows.push(
      <div className="grid grid-cols-7" key={day}>
        {days}
      </div>,
    );
    days = [];
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = [];
  for (let y = today.getFullYear() - 5; y <= today.getFullYear() + 5; y++) {
    years.push(y);
  }

  const [showPopup_filter, setShowPopup_filter] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowPopup_filter(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Calendar
            </p>
          </div>

          <div className="flex items-center gap-1">
            <div className="flex items-center">
              <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
                <div className="flex items-center justify-center fill-[#1D2826]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Isolation_Mode"
                    data-name="Isolation Mode"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                  >
                    <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
                />
              </div>

              <div className="">
                <button className="Btn">
                  <svg
                    className="svgIcon"
                    viewBox="0 0 384 512"
                    height="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
                  </svg>
                  <span className="icon2"></span>
                  <span className="tooltip text-sm">Download</span>
                </button>
              </div>

              <div className="flex items-center">
                <div className="relative inline-block" ref={filterRef}>
                  <div
                    onClick={() => setShowPopup_filter((prev) => !prev)}
                    className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${
                      showPopup_filter
                        ? "border-[#1D2826]"
                        : "border-transparent hover:border-[#1D2826]"
                    }`}
                  >
                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "0%" : "100%",
                          transform: `translate(${
                            showPopup_filter ? "0" : "-100%"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>
                  </div>

                  {showPopup_filter && (
                    <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
                      <div className="flex justify-between gap-2">
                        {["Today", "Week", "Month", "Year"].map((label) => (
                          <button
                            key={label}
                            className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
                          >
                            {label}
                          </button>
                        ))}
                      </div>

                      <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                          <span className="text-sm text-gray-500">-</span>
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Calendar */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4 my-10">
          <div className="flex gap-4">
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              className="text-sm border px-3 py-1 rounded-lg shadow focus:ring-0 focus:border-black"
            >
              {months.map((month, index) => (
                <option value={index} key={month}>
                  {month}
                </option>
              ))}
            </select>
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="text-sm border px-3 py-1 rounded-lg shadow focus:ring-0 focus:border-black"
            >
              {years.map((year) => (
                <option value={year} key={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-7 mb-2 font-bold text-center">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
            <div key={day}>{day}</div>
          ))}
        </div>

        {/* Calendar Grid */}
        {rows}

        {selectedDate && (
          <div
            className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
            onClick={() => setSelectedDate(null)}
          >
            <div className="bg-white rounded-lg w-96 mx-5 p-4 shadow-xl">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-bold">
                  Bookings on {selectedDate}
                </h3>
                <button
                  className="text-gray-400 font-semibold hover:text-gray-700"
                  onClick={() => setSelectedDate(null)}
                >
                  <MdCancel />
                </button>
              </div>
              <ul className="space-y-2 max-h-[80vh] overflow-y-auto">
                {bookingsData[selectedDate]?.map((b, i) => (
                  <li
                    key={i}
                    className="border p-2 rounded bg-gray-100 text-sm"
                  >
                    <strong>{b.property}</strong> <br /> Guest: {b.guest}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default Calendar;
